import { z } from 'zod';

const orderItemSchema = z.object({
  code: z.string().optional(),
  name: z.string().min(1, 'Test name is required'),
});

export const orderSchema = z.object({
  type: z.enum(['lab', 'radiology']),
  items: z.array(orderItemSchema).min(1, 'At least one test is required'),
  priority: z.enum(['normal', 'urgent']),
  notes: z.string().optional(),
});

export type OrderFormData = z.infer<typeof orderSchema>;
